import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeeight-courses',
  templateUrl: './homeeight-courses.component.html',
  styleUrls: ['./homeeight-courses.component.scss']
})
export class HomeeightCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
